import { arrayOf, func, shape, string } from 'prop-types'
import { PureComponent } from 'react'

import { withI18n } from 'shared/utils/withI18n'
import Select from 'views/components/molecules/Select'
import { i18nType } from 'views/utils/propTypes'

class VariantsMobile extends PureComponent {
  getVariant = id => {
    return this.props.variants.find(variant => variant.id === id)
  }

  handleChange = event => {
    const { updateCurrentVariant } = this.props
    if (typeof updateCurrentVariant === 'function') {
      updateCurrentVariant(this.getVariant(event.target.value))
    }
  }

  render() {
    const { currentVariantId, variants, i18n } = this.props
    const options = variants.map(({ id, unitQuantityString, unit }) => ({
      value: id,
      text: `${unitQuantityString} ${unit}`,
    }))

    return (
      <Select
        id="FilteredProductListItem__variantsMobile"
        name="FilteredProductListItem__variantsMobile"
        label={i18n._('general.label.availableVariants')}
        selectedValue={currentVariantId}
        onChange={this.handleChange}
        options={options}
      />
    )
  }
}

VariantsMobile.propTypes = {
  currentVariantId: string,
  variants: arrayOf(shape({})).isRequired,
  updateCurrentVariant: func,
  i18n: i18nType.isRequired,
}

VariantsMobile.defaultProps = {
  currentVariantId: null,
  updateCurrentVariant: null,
}

export default withI18n()(VariantsMobile)
